import { render, staticRenderFns } from "./InvolvedClinicalCard.vue?vue&type=template&id=f22ea4ce&scoped=true&"
import script from "./InvolvedClinicalCard.vue?vue&type=script&lang=js&"
export * from "./InvolvedClinicalCard.vue?vue&type=script&lang=js&"
import style0 from "@/components/involved/panels/panel-styles.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./InvolvedClinicalCard.vue?vue&type=style&index=1&id=f22ea4ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22ea4ce",
  null
  
)

export default component.exports